// extracted by mini-css-extract-plugin
export var button = "ContactForm-module--button--66c5c typography-module--paragraphSansMedium--1b5f1";
export var buttonSuccessWrapper = "ContactForm-module--buttonSuccessWrapper--60145";
export var contactFormContainer = "ContactForm-module--contactFormContainer--3c900";
export var countryCode = "ContactForm-module--countryCode--00d2b";
export var hidden = "ContactForm-module--hidden--2e1b9";
export var messageError = "ContactForm-module--messageError--a91b7";
export var mobileSubTitle = "ContactForm-module--mobileSubTitle--bec07 typography-module--responsiveTitle4--45808";
export var mobileSuccessMessage = "ContactForm-module--mobileSuccessMessage--7638c";
export var phoneNumber = "ContactForm-module--phoneNumber--0aa56";
export var phoneWrapper = "ContactForm-module--phoneWrapper--8d29c";
export var subTitle = "ContactForm-module--subTitle--15031 typography-module--responsiveTitle4--45808";
export var successMobileIcon = "ContactForm-module--successMobileIcon--bd766";
export var successMobileTitle = "ContactForm-module--successMobileTitle--42410";
export var textArea = "ContactForm-module--textArea--fe6db";
export var title = "ContactForm-module--title--e9d23 typography-module--responsiveTitle3--2bebc";
export var wrapper = "ContactForm-module--wrapper--3a101";